import Button from "@ingka/button";

type Props = {
  onApprove: () => void;
  onDeny: () => void;
  onFeedback: () => void;
  assetSelection: string[];
  uploadDone: boolean;
  isLoading: boolean;
};

const TopButtons = ({
  onApprove,
  onDeny,
  onFeedback,
  assetSelection,
  uploadDone,
  isLoading,
}: Props) => (
  <div>
    <Button
      size="medium"
      text="Approve selected asset(s)"
      type="emphasised"
      onClick={onApprove}
      disabled={assetSelection.length === 0 || uploadDone}
      loading={isLoading}
    />
    <Button
      text="Deny selected asset(s)"
      className="ml-space150"
      onClick={onDeny}
      disabled={assetSelection.length === 0 || uploadDone}
      loading={isLoading}
    />
    <Button
      size="medium"
      text="Send feedback to user"
      type="primary"
      className="ml-space150"
      onClick={onFeedback}
      disabled={uploadDone}
      loading={isLoading}
    />
  </div>
);

export default TopButtons;
